import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { useStyles } from './styles';
import Image from 'next/image';
import LazyLoad from 'react-lazyload';
import useIsMobile from 'hooks/useIsMobile';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

export default function Features() {
  const classes = useStyles();
  const isMobile = useIsMobile();
  const router = useRouter();
  const { t } = useTranslation('pricing');

  return (
    <Box className={classes.boxFeatures}>
      <LazyLoad>
        <Container>
          {router.pathname === '/anniversary' ? (
            <>
              <Typography className={classes.titleHeroBlack} component="h2">
                {t('features_section.anniversary_title')}
              </Typography>
            </>
          ) : (
            <>
              <span className={classes.tagPage}>{t('features_section.tag')}</span>
              <Typography className={classes.titleHero} component="h2">
                {t('features_section.title')} <br />
                <b>{t('features_section.title_bold')}</b>
              </Typography>

              <Box pb={6.5}>
                <Typography className={classes.subtitle} component="p">
                  {t('features_section.subtitle')}
                </Typography>
              </Box>
            </>
          )}

          <Grid container spacing={4} justifyContent="center" alignItems="flex-start">
            <Grid item xs={12} sm={4}>
              <Box maxWidth={363} width="100%" pl={isMobile ? 2 : 0}>
                <Image
                  src="/images/pricing/drag-drop.svg"
                  width={48}
                  height={48}
                  alt={t('features_section.cards.drag_drop.title')}
                  loading="lazy"
                />

                <Typography variant="h4" component="p" className={classes.titleCard}>
                  {t('features_section.cards.drag_drop.title')}
                </Typography>

                <Typography component="p" className={classes.describeCard}>
                  {t('features_section.cards.drag_drop.description')}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Box maxWidth={363} width="100%" pl={isMobile ? 2 : 0}>
                <Image
                  src="/images/pricing/pre-made.svg"
                  width={48}
                  height={48}
                  alt={t('features_section.cards.pre_made.title')}
                  loading="lazy"
                />

                <Typography variant="h4" component="p" className={classes.titleCard}>
                  {t('features_section.cards.pre_made.title')}
                </Typography>

                <Typography component="p" className={classes.describeCard}>
                  {t('features_section.cards.pre_made.description')}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Box maxWidth={363} width="100%" pl={isMobile ? 2 : 0}>
                <Image
                  src="/images/pricing/slides.svg"
                  width={48}
                  height={48}
                  alt={t('features_section.cards.slides.title')}
                  loading="lazy"
                />

                <Typography variant="h4" component="p" className={classes.titleCard}>
                  {t('features_section.cards.slides.title')}
                </Typography>

                <Typography component="p" className={classes.describeCard}>
                  {t('features_section.cards.slides.description')}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Box maxWidth={363} width="100%" pl={isMobile ? 2 : 0}>
                <Image
                  src="/images/pricing/multiple.svg"
                  width={48}
                  height={48}
                  alt={t('features_section.cards.sizing.title')}
                  loading="lazy"
                />

                <Typography variant="h4" component="p" className={classes.titleCard}>
                  {t('features_section.cards.sizing.title')}
                </Typography>

                <Typography component="p" className={classes.describeCard}>
                  {t('features_section.cards.sizing.description')}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Box maxWidth={363} width="100%" pl={isMobile ? 2 : 0}>
                <Image
                  src="/images/pricing/onDemand.svg"
                  width={48}
                  height={48}
                  alt={t('features_section.cards.on_demand.title')}
                  loading="lazy"
                />

                <Typography variant="h4" component="p" className={classes.titleCard}>
                  {t('features_section.cards.on_demand.title')}
                </Typography>

                <Typography component="p" className={classes.describeCard}>
                  {t('features_section.cards.on_demand.description')}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Box maxWidth={363} width="100%" pl={isMobile ? 2 : 0}>
                <Image
                  src="/images/pricing/clound.svg"
                  width={48}
                  height={48}
                  alt={t('features_section.cards.online.title')}
                  loading="lazy"
                />

                <Typography variant="h4" component="p" className={classes.titleCard}>
                  {t('features_section.cards.online.title')}
                </Typography>

                <Typography component="p" className={classes.describeCard}>
                  {t('features_section.cards.online.description')}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </LazyLoad>
    </Box>
  );
}
